import { AxiosResponse } from 'axios';
import ApiConstants from '../../../../core/constants/api_constants';
import { request } from '../../../../core/network/axiosInstance';

export class ResourceApiService {
  private readonly resourceBaseUrl: string;

  constructor() {
    this.resourceBaseUrl = ApiConstants().resource;
  }

  async getResourceByThemeId(id: string): Promise<AxiosResponse> {
    const response = await request({
      method: 'GET',
      url: `${this.resourceBaseUrl}theme/${id}`,
      requiresToken: true,
    });
    return response;
  }

  async getResourceById(id: string): Promise<AxiosResponse> {
    const response = await request({
      method: 'GET',
      url: `${this.resourceBaseUrl}${id}`,
      requiresToken: true,
    });
    return response;
  }
}
